module.exports = __webpack_public_path__ + "img/nbq_mac.3b5d978a.png";